<template>
    <el-dialog
        title="甘肃省中小企业融资综合信用服务平台用户服务及授权协议"
        :visible.sync="agreementDialog"
        :close-on-click-modal="false"
        width="850px"
        :close-on-press-escape="false"
        custom-class="agreementDialog"
        :before-close="closeAgreementDialog"
    >
        <div class="el-dialog--body">
            <div class="agreement-container">
                <div class="agreement-content">
                    <p class="content-text">
                        本协议适用于使用甘肃省中小企业融资综合信用服务平台相关服务。在注册使用平台服务前，请您务必审慎阅读本协议，特别是其中与用户信息保护和共享、风险与免责、送达、争议解决相关的条款，以及以粗体、下划线标识的部分。在确认已完全充分理解并同意使用相关产品或服务后，您可以勾选“我已阅读并同意《甘肃省中小企业融资综合信用服务平台用户服务及授权协议》并点击“确认提交”的方式签署本协议并完成注册程序，成为本平台用户，同时代表自愿接受本协议的约束。若您不同意本协议，应立即停止注册或停止使用平台服务和产品。平台的所有权、运营权、解释权及本协议条款的解释、修改归平台所有。
                    </p>
                    <p class="content-text">
                        如果您在任何时候对任何内容存在疑虑或异议，请您立即联系我们（联系方式：0931-8101279；邮箱：gssxyd@126.com
                        ），以便我们对相关内容进行解释和说明，使您能够充分理解，从而帮助您决定是否接受本协议及使用平台的服务。
                    </p>
                    <h4 class="content-title">
                        <span>第一条 定义、平台服务内容和方式</span>
                    </h4>
                    <p class="content-text">1.1 定义</p>
                    <p class="content-text">
                        1.1.1
                        甘肃省中小企业融资综合信用服务平台（以下简称“平台”）：指由中国经济信息社有限公司（以下简称“甲方”）运营，为中小微企业及关联方与金融机构等适格机构、中介机构之间的投融资行为提供信息发布、信息交互、交易撮合服务及其它增值服务的平台。
                    </p>
                    <p class="content-text">
                        1.1.2
                        本协议中的”第三方机构“是指具备投资/融资服务资质，在平台上发布投资/融资产品及相关信息的金融机构或非金融机构、金融服务中介机构等
                    </p>
                    <p class="content-text">
                        1.1.3
                        平台用户（以下简称“乙方”）应遵守包括协议正文及所有甲方已经发布的或者将来可能发布的各类平台规则。所有规则与本协议具有同等法律效力，不因是否列举在本协议或因发布时间、发布方式的不同而影响其效力。
                    </p>
                    <p class="content-text">
                        1.1.4
                        本协议所指的乙方信息包括但不限于乙方在平台主动填报的信息、乙方在使用平台服务过程中生成的信息，以及甲方、甲方合作方（包括但不限于平台上第三方机构等）依法获取的乙方公开信息、依法从其他信息提供者处获取的乙方其他信息。
                    </p>
                    <p class="content-text">1.2 服务内容和方式</p>
                    <p class="content-text">
                        1.2.1
                        平台将乙方自行填报或上传的信息提供给乙方通过本平台申请投资、融资产品或服务以及政府补贴资格的第三方机构及该第三方机构指定的其他主体，用于第三方机构投资/融资审批、补贴资格审核和投后/贷后管理等用途。
                    </p>
                    <p class="content-text">
                        1.2.2
                        为丰富平台功能，便于用户享受多元化服务，平台会以链接跳转、页面跳转等方式提供第三方增值服务，用户可依据自身需要自愿选择，平台不保证第三方增值服务的主体资质合法性以及服务效果的真实性、完整性、有效性，相关权利、义务与责任由用户和第三方增值服务提供方承担。
                    </p>
                    <p class="content-text">
                        1.2.3
                        平台运营初期将向用户提供阶段性的免费服务。甲方保留单方面制定及调整平台服务费用收费标准的权利，并将通过邮件、平台公告、登录提示等方式，告知乙方各项平台服务收费说明及收费标准并另行签订协议。乙方不同意甲方调整
                        后的平台服务收费标准的，可在接到甲方通知后注销账号，停止使用平台服务。
                    </p>
                    <p class="content-text">
                        1.2.4
                        平台仅作为用户搜寻投资/融资服务机构、政府补贴项目，就投资/融资、政府补贴申请等过程进行协商以及获取各类与投资/融资、政府补贴相关服务的媒介，甲方及平台并不作为出资方或融资方参与投资或融资交易。平台上第三方机构发布的相关信息及投资/融资产品的合法性、安全性、真实性、准确性均由该第三方机构完全、独立的负责；甲方不能控制平台上第三方机构发布的信息和投资/融资产品的合法性、安全性、真实性、准确性，也不能控制投资/融资交易各方履行相关交易服务协议的能力。甲方提醒乙方应该通过自己的谨慎判断，确定申请金融产品或获取相关信息的真实性、合法性和有效性。
                    </p>
                    <p class="content-text">
                        <b
                            >1.2.5
                            由于平台建设是持续完善的过程，可能会出现个别服务暂未开通或个别功能需进一步完善的情形，乙方应知悉并充分理解上述情况，确认不能仅因上述原因追究平台或甲方任何责任。</b
                        >
                    </p>
                    <h4 class="content-title">
                        <span>第二条 账户注册与使用</span>
                    </h4>
                    <p class="content-text">2.1 注册资格</p>
                    <p class="content-text">
                        乙方应当是依法成立并合法存续的企业法人或其他组织（包括股份有限公司、有限责任公司、合伙企业、个人独资企业、个体工商户等），并应确保具备签署本协议、使用平台服务所需的各项授权、证照、批准和资质。
                    </p>
                    <p class="content-text">2.2 账户注册</p>
                    <p class="content-text">
                        2.2.1
                        乙方在平台注册或使用平台服务时须按照平台的要求提供必要的信息或材料。<b
                            >乙方须保证注册和使用平台服务过程中所提供的一切信息和材料真实、准确、完整、合法，且不侵犯任何其他主体合法权益，否则不得使用平台服务或使用过程中将受到限制/禁止。甲方有权基于单方独立判断，在认为乙方出现违反上述约定情形时，采取删除或屏蔽乙方发布的信息，立即暂停或注销乙方账户，限制或禁止乙方使用平台服务等措施。如乙方有书面证据证明其未违反上述约定，应及时
                            联系甲方并通过邮寄方式向甲方提交书面证据，经甲方审核后决定是否解除对乙方的限制或禁止。对因乙方提供的信息或材料不真实、不准确、不完整或不合法产生的一切责任由乙方自行承担，且乙方应对由此造成平台的直接及间接损失承担赔偿责任。</b
                        >
                    </p>
                    <p class="content-text">
                        2.2.2
                        乙方向平台提交注册申请后，甲方有权对乙方提供的信息和材料进行审查，并有权最终决定是否接受乙方的注册申请。
                    </p>
                    <p class="content-text">2.3 合法依约使用</p>
                    <p class="content-text">
                        2.3.1
                        乙方在使用平台服务过程中，提供的信息或材料发生变动时，应及时进行更新，因未及时更新造成的平台服务迟延、无法正常提供服务等情况，甲方不承担任何法律责任。
                    </p>
                    <p class="content-text">
                        <b
                            >2.3.2
                            申请注册、签署本协议、登录账户使用平台服务等行为均由乙方授权委托的自然人（实际操作人员）完成，乙方应保证实际操作人员具备与其所从事行为相适应的民事行为能力，并已获得乙方的合法、全面、有效授权，乙方对实际操作
                            人员在平台中实施的一切操作承担相应的法律后果。</b
                        >
                    </p>
                    <p class="content-text">
                        2.3.3
                        乙方的实际操作人员登录平台后，应根据相关页面的操作说明或与甲方签署的其他协议等使用相关系统功能。
                    </p>
                    <p class="content-text">
                        2.3.4
                        乙方确认知悉，甲方将依据本协议和/或其他有关文件和规则对乙方在平台中提交的操作指令进行处理。乙方未能及时对操作指令进行修改、确认所引起的任何纠纷或损失均由乙方自行负责，甲方不承担任何责任。
                    </p>
                    <p class="content-text">
                        2.3.5
                        乙方不得在其网站或关联公司的网站以文字、图形、链接等任何方式直接或间接进行有损平台及甲方、甲方股东、员工名誉或利益的行为，不得在未经甲方书面同意的情况下使用平台或甲方名称、商标或者以平台或甲方的名义从事任何活动。
                    </p>

                    <h4 class="content-title">
                        <span>第三条 用户名和密码安全</span>
                    </h4>
                    <p class="content-text">
                        3.1
                        乙方在平台注册成功后，乙方须妥善保管用户名和密码，不得将账户以转让、出租、出借等任何方式提供给其他主体使用。乙方确认，凡使用用户名和密码成功登录后在平台上所作的一切操作，均视为乙方的操作，所产生的电子信息记录均为乙方行为的有效凭据，以及由此产生的所有法律后果均由乙方自行承担。甲方对乙方的用户名或密码遗失、被盗等所产生的后果不承担任何责任。
                    </p>
                    <p class="content-text">
                        3.2 乙方应审慎设置和保管密码，并应：
                    </p>
                    <p class="content-text">
                        3.2.1 避免使用与乙方明显相关的数字作为密码；
                    </p>
                    <p class="content-text">
                        3.2.2
                        乙方申请甲方代为注册的，收到初始登录密码后，应在首次登录平台时重新设置登录密码，若乙方未进行重置造成损失的，由乙方自行承担；
                    </p>
                    <p class="content-text">3.2.3 定期更换密码并牢记；</p>
                    <p class="content-text">
                        3.2.4 在设备上输入密码时，防止旁人或不安全设备窥视；
                    </p>
                    <p class="content-text">
                        3.2.5
                        发现密码泄露、被盗、遗忘等情况，及时办理密码重置手续。
                    </p>

                    <h4 class="content-title">
                        <span>第四条 暂停和注销账户</span>
                    </h4>
                    <p class="content-text">
                        4.1
                        乙方若发现有第三人冒用或盗用乙方的账户及密码，或其他任何未经合法授权使用平台服务的情形，应立即修改账号密码并妥善保管，如有必要，应通过发送邮件或拨打客服电话等方式联系甲方采取合理、必要手段协助乙方防止损失扩大。乙方理解，甲方对乙方的请求采取行动需要合理期限和程序，在此之前，甲方对第三人使用平台服务所导致的乙方损失不承担任何责任。同时，<b
                            >乙方理解，甲方即使及时采取了合理、必要手段，也并非确定能够防止乙方出现损失。</b
                        >
                    </p>
                    <p class="content-text">
                        <b
                            >4.2
                            乙方承诺对其发表或者上传于平台的所有信息（即属于《中国人民共和国著作权法》规定的作品，包括但不限于文字、图片、音乐、电影、表演和录音录像制品和电脑程序等）均享有完整的知识产权，或者已经得到相关权利人的授权，亦不会侵犯他人的其他合法权益；如乙方违反本条规定造成本平台被第三人索赔的，乙方应全额赔偿本平台一切损失（包括但不限于各种赔偿费、诉讼费、律师费及为此支出的其他合理费用）。当第三方认为乙方发表或者上传于本平台的信息侵犯其权利，并根据《信息网络传播权保护条例》或者相关法律规定向本平台发送权利通知书时，乙方同意本平台可以自行判断决定删除涉嫌侵权信息，除非乙方提交书面证据材料排除侵权的可能性，否则本平台将不会自动恢复上述删除的信息。</b
                        >
                    </p>
                    <p class="content-text">
                        <b
                            >4.3
                            甲方有权基于单方独立判断，在认为可能发生危害乙方合法利益情形时，不经通知而先行暂停、中断或终止向乙方提供平台服务，且无需对乙方或任何其他主体承担任何责任。</b
                        >
                    </p>
                    <p class="content-text">
                        4.4
                        乙方确认并同意，乙方账户的暂停或注销不代表乙方责任的终止，乙方仍应对乙方使用平台服务期间的行为承担相关责任，包括但不限于可能的违约或损害赔偿责任，同时甲方仍有权依法保有乙方的相关信息。
                    </p>
                    <p class="content-text">
                        4.5
                        如用户在使用网络服务时违反下述任何规定，本平台有权要求用户改正或直接采取一切必要的措施（包括但不限于删除用户张贴的内容、暂停或终止用户使用网络服务的权利）以减轻用户不当行为而造成的影响。
                    </p>
                    <p class="content-text">
                        4.5.1 不得为任何非法目的而使用网络服务系统；
                    </p>
                    <p class="content-text">
                        4.5.2 遵守所有与网络服务有关的网络协议、规定和程序；
                    </p>
                    <p class="content-text">
                        4.5.3
                        不得利用本平台进行任何可能对互联网的正常运转造成不利影响的行为；
                    </p>
                    <p class="content-text">
                        4.5.4 不得利用本平台进行任何不利本平台的行为。
                    </p>
                    <h4 class="content-title">
                        <span>第五条 乙方信息授权</span>
                    </h4>
                    <p class="content-text">5.1 授权条款</p>
                    <p class="content-text">
                        <b
                            >5.1.1
                            乙方在此授权平台在合法合规、不违反监管规定的前提下，采集企业的基本信息、企业的汇总经营信息、企业的负面信息、企业的金融信息等企业向相关部门提供的和相关部门在管理工作中产生的信息，以及企业在生产经营过程中产生的相关信用信息；国家法律、行政法规、部门规章、地方性法规未禁止采集的与授权企业有关的其他信息。</b
                        >
                    </p>
                    <p class="content-text">
                        <b
                            >5.1.2
                            可以向第三方机构提供乙方跳转到其他链接后，因自愿在该链接上选择填报上传企业信息而形成的财务分析报告、企业评估报告等的链接。本条款同时适用于第1.2.2条款相关约定。</b
                        >
                    </p>
                    <p class="content-text">
                        <b
                            >5.2
                            乙方在此授权第三方机构在合法合规、不违反监管规定的前提下可以向平台查询使用上述信息，并授权平台将该信息提供给第三方机构。</b
                        >
                    </p>
                    <p class="content-text">
                        <b
                            >5.3
                            乙方在此承诺国家机关、政府部门、事业单位等部门和单位，因行政管理、公共服务的需要，可以直接查询乙方的上述信息。平台可以向上述部门和单位提供上述信息。</b
                        >
                    </p>
                    <p class="content-text">
                        5.4 本授权自协议签订之日起生效，授权期限为长期。
                    </p>
                    <p class="content-text">
                      5.5 乙方在此声明已知悉并理解本授权委托书，以及因提供非公开信息及负面信息可能导致的任何不利后果。
                    </p>
                    <p class="content-text">
                      <b>5.6 免责情形</b>
                    </p>
                    <p class="content-text">
                      <b>有下列情况之一，造成乙方信息丢失、泄露、损毁或造成其他损失的，甲方将不承担任何法律责任：</b>
                    </p>
                    <p class="content-text">
                      <b>5.6.1 任何由于黑客攻击、计算机病毒侵入或发作、因政府管制而造成的损失；</b>
                    </p>
                    <p class="content-text">
                      <b>5.6.2 乙方自身原因（包括但不限于自身泄露账号密码等）导致的损失；</b>
                    </p>
                    <p class="content-text">
                      <b>5.6.3 因其他主体原因导致的损失；</b>
                    </p>
                    <p class="content-text">
                      <b>5.6.4 因战争、地震、火灾、恐怖袭击、罢工、政府行为等不可抗力引起的任何后果；</b>
                    </p>
                    <p class="content-text">
                      5.7 其他约定
                    </p>
                    <p class="content-text">
                      <b>5.7.1 平台提供的乙方信息服务仅供信息使用者参考，甲方对信息使用者根据乙方信息作出的判断、决定以及所从事的活动等行为及其后果不承担任何法律责任。</b>
                    </p>
                    <p class="content-text">
                      <b>5.7.2 乙方确认，在同意接受平台服务时已清楚知晓就此可能带来的不利后果，包括但不限于第三方机构查看乙方信息中含有负面评价等。乙方确认充分知悉自身的负面信息（如有）可能影响信息使用者对乙方的信用评价。</b>
                    </p>

                    <h4 class="content-title"><span>第六条 知识产权</span></h4>
                    <p class="content-text">
                      6.1 除本协议另有约定外，平台的所有交易数据、技术、程序、软件及其他信息的所有权利（包括但不限于版权、商标权、专利权、商业秘密及其他相关权利）均归甲方根据法律规定或内部协议约定所有/分别所有。除非经甲方事先书面同意，乙方不得以任何形式向任何其 他主体公开发表、传输、复制或以其他方式使用甲方的全部或部分信息，不得更改、虚化或删除任何署名、商标、版权标识和/或其他权利声明。
                    </p>
                    <p class="content-text">6.2 乙方不得对甲方软件系统程序（包括但不限于源程序、目标程序、软件文档等）进行反向工程、反向编译、反汇编或以其他方式尝试发现本系统的源代码；不得复制、修改、编译、整合、篡改、传播与甲方软件系统相关的材料等侵犯甲方合法权利的行为，否则乙方应承担由此给甲方造成的所有损失。
                    </p>

                    <h4 class="content-title"><span>第七条 风险与免责</span></h4>
                    <p class="content-text">
                        <b>7.1 因任何甲方不能预见、不能避免且不能克服的情形（“不可抗力事件”）或其他主体原因造成甲方无法提供或迟延提供服务的，在不可抗力事件或其他主体原因影响的范围内，甲方不承担任何违约或赔偿责任。不可抗力事件及其他主体原因包括但不限于以下内容：</b>
                    </p>
                    <p class="content-text">
                        <b>7.1.1 自然灾害、罢工、骚乱、战争、政府行为、司法行政命令等不可抗力事件；</b>
                    </p>
                    <p class="content-text">
                        <b>7.1.2 电力供应故障、通讯网络故障、黑客攻击、计算机病毒等因素；</b>
                    </p>
                    <p class="content-text">
                        <b>7.1.3 任何其他主体原因。</b>
                    </p>
                    <p class="content-text">
                        <b>7.2 在以下情况，甲方不承担任何责任：</b>
                    </p>
                    <p class="content-text">
                        <b>7.2.1 甲方不承诺乙方融资、投资对接的成功，因任何原因（包括但不限于乙方发布的资料、信息不真实、不合法、不完整，乙方融资需求与第三方融资条件不匹配等）导致对接不成功的，甲方不承担任何法律责任。</b>
                    </p>
                    <p class="content-text">
                        <b>7.2.2 乙方在平台服务中选择平台上第三方机构为乙方提供服务的，甲方对平台上第三方机构的任何行为不承担任何责任，乙方应自行解决与平台上第三方机构之间的争议或纠纷。</b>
                    </p>
                    <p class="content-text">
                        <b>7.2.3 乙方应独立审慎地依据从平台获取的信息作出判断和决策，甲方无法保证乙方作出决策所依据的信息、数据等充分、及时、准确、完整和有效，甲方免于承担由乙方自行判断和决策所引起的任何法律责任。</b>
                    </p>
                    <p class="content-text">
                        <b>7.2.4 甲方不对平台中展示的第三方网站或资源的可用性、合法性等负责，乙方通过点击相关链接离开平台后跳转至第三方网站或资源而遭受的任何直接或间接损失，甲方均不承担责任。</b>
                    </p>
                    <p class="content-text">
                      7.3 甲方在有证据证明乙方或具体交易事项存在违法违规或违反本协议等问题时（包括但不限于违反用户所做承诺或约定义务、违反平台规则等）或其他平台认为任何应当终止服务的情况，甲方有权根据不同情况选择采取删除或屏蔽乙方发布的信息、限制或终止全部或部分服务、警告、公示、解除协议、列入黑名单、网站公示等一项或多项处理措施，并保留追究其法律责任的权利。
                    </p>
                    <p class="content-text">
                        <b>7.4用户理解，甲方需要定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，如因此类情况而造成本网站服务在合理时间内的中断，甲方无需为此承担任何责任，但甲方应尽可能事先进行通告。</b>
                    </p>
                    <p class="content-text">
                        <b>7.5尽管本协议有其他规定，如果任何因乙方使用平台服务而产生的或以任何方式与之相关的损害或损失，甲方应向乙方承担的责任，在任何情况下不超过甲方就相关违约事项向乙方收取的服务费用。</b>
                    </p>
                    <p class="content-text">
                        <b>7.6无论在任何情况下，甲方均不承担由本协议引起或与本协议有关的任何间接的、偶然性的损失，包括但不限于商业机会的损失、利润的损失、商誉的损失等。</b>
                    </p>
                    <h4 class="content-title"><span>第八条 协议的组成和修订</span></h4>
                    <p class="content-text">
                      8.1 本协议内容包括协议正文及所有平台已经发布的或将来通过平台官网可能发布或修改的各类规则，服务协议、免责声明等（以下简称“规则”），所有规则均为本协议不可分割的组成部分，与协议正文具有同等法律效力，乙方在接受相关服务前应仔细阅读并理解协议全部内容。除平台另行明确声明外，任何与平台有关的一切服务、交易及非交易活动均受本协议约束。
                    </p>
                    <p class="content-text">
                        <b>8.2 甲方有权根据其互联网的发展状况、法律法规和行业监管规定变化等，不时对本协议进行必要修订，该等修改包括但不限于平台服务模式发生重大变化，如处理乙方信息的目的、乙方信息的使用方式等；甲方在控制权、组织架构、内部合作模式、合作对象等方面发生重大变化；乙方信息共享、转让或公开披露的主要对象发生变化；甲方负责处理乙方信息安全的责任部门、联络方式及投诉渠道发生变化等。如发生上述变化，甲方将通过平台公告、推送等其他合理方式进行发布，乙方应随时关注并阅读最新版的协议及平台公告。乙方应通过平台提供的合理方式确认是否接受协议修改内容；若乙方不同意所修改的内容，应当立即停止使用本平台相关服务；若乙方在协议修订后继续使用平台服务，视为乙方同意并接 受修改后的协议。平台运营方通过本平台发布的通知、公告、声明或其他类似的内容是本协议的组成部分。</b>
                    </p>
                    <h4 class="content-title"><span>第九条 通知和送达</span></h4>
                    <p class="content-text">
                      9.1 除法律法规或监管规定另有强制性规定外，本协议履行过程中，甲方将按照乙方向甲方提供的通讯地址（包括但不限于证件地址、办公地址、平台账号等）送达书面通知，书面通知的形式还包括向乙方发送电子邮件、平台站内信、系统信息、手机短信、传真、发布网站公告等方式。通过邮政快递方式的，交邮后的第三个自然日视为已送达；通过电子方式的，发出当天视为已送达。采用一种以上方式发出通知的，以最先送达的时间为送达时间。
                    </p>
                    <p class="content-text">
                        9.2 乙方同意司法机关按照乙方向甲方提供的通讯地址，以手机短信、电子邮件或邮寄送达的方式向乙方送达法律文书。乙方同意上述送达方式适用于各个司法阶段。
                    </p>
                    <p class="content-text">
                      9.3 乙方联系方式需变更的，应提前5个工作日向甲方和司法机关等（若争议已经进入司法程序解决）送交书面变更告知书；否则，乙方应自行承担因联系方式不准确、无效等导致通知、文件等无法送达的法律后果。
                    </p>

                    <h4 class="content-title"><span>第十条 法律适用和争议解决</span></h4>
                    <p class="content-text">
                      10.1 本协议的效力、解释、变更、执行及争议的解决等均适用中华人民共和国法律。
                    </p>
                    <p class="content-text">
                      10.2 因本协议产生的任何争议，双方应协商解决；协商不成的，应提交甲方所在地有管辖权的人民法院裁决。诉讼期间，甲、乙双方须继续执行本协议中除争议部分之外的其他条款。
                    </p>

                    <h4 class="content-title"><span>第十一条 协议生效与终止</span></h4>
                    <p class="content-text">
                        <b>11.1 乙方于服务页面勾选“我已阅读并同意《甘肃省中小企业融资综合信用服务平台用户服务及授权协议》”并点击“提交”视为乙方同意接受本协议并注册成为本平台用户，认可由第三方服务商提供的电子合同的签署方式，认可通过第三方服务平台签订的电子合同（或协议）和纸质合同（或协议）具备相同的效力，认可使用第三方服务商提供的电子签名和用户公章、手写签名具备相同的效力。本协议自乙方签署之时起成立并生效。本条款的电子合同签署方式同样适用于本协议第一条第1.2.3款项及第八条第8.2款协议修改变更的签订和确认（勾选和点击内容等具体方式可能会根据确认内容的不同有所变化）。</b>
                    </p>
                    <p class="content-text">
                      11.2 如乙方要终止本协议，应提前一个月书面通知甲方，对于因乙方终止本服务协议而对其申请、使用平台上的金融机构产品及服务产生的任何不利影响及损失，由乙方自行承担，甲方不承担任何责任。如果乙方与平台上的第三方机构之间 的融资关系、投资关系、结算关系等尚未终止，则乙方须待有关的融资关系、投资关系、结算关系等终止后方可终止本用户授权及服务协议。
                    </p>
                    <p class="content-text">
                      11.3 如乙方账户注销后，甲方将停止为乙方提供平台服务，根据法律要求删除乙方信息或使其匿名化处理。
                    </p>

                    <h4 class="content-title"><span>第十二条 版权说明</span></h4>
                    <p class="content-text">
                        <b>12.1乙方在平台发表任何形式的信息，均表明该用户主动将该信息的汇编权、信息网络传播权无偿转让给本平台。本协议已经构成《著作权法》第二十五条所规定的书面协议，并在乙方同意接受本注册协议时生效，其效力及于乙方此后在本平台发布的任何内容。乙方同意并明确了解上述条款，不将上述任何信息，以任何形式发布或授权其他网站（及媒体）使用。</b>
                    </p>
                    <p class="content-text">
                      12.2平台的所有交易数据及其他信息的知识产权归甲方所有或甲方已获得相应授权，未经甲方同意，乙方不得将从本平台获取的任何信息，以任何形式发布或授权其他网站（及媒体）使用。
                    </p>

                    <h4 class="content-title"><span>第十三条 其他</span></h4>
                    <p class="content-text">
                      13.1 本协议的标题仅为阅读方便，不构成对本协议的任何解释，对标题项下内容及其范围也不构成任何限制。
                    </p>
                    <p class="content-text">
                        <b>13.2 若本协议的任一条款被视为无效或不可执行，不影响本协议其余条款的有效性及可执行性。</b>
                    </p>
                    <p class="content-text">
                      （以下无正文）
                    </p>
                    
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                @click="closeAgreementDialog"
                type="primary"
                plain
                size="small"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>
<script>
export default {
    name: "AgeementComponents",
    props: {
        agreementDialog: {
            type: Boolean,
            default: () => {
                return false;
            },
            required: true,
        },
    },
    watch: {
        agreementDialog: {
            deep: true,
            handler(newVal, oldVal) {
                this.agreementDialog = oldVal !== newVal ? newVal : oldVal;
            },
            immediate: true,
        },
    },
    methods: {
        closeAgreementDialog() {
            this.$emit("closeAgreementDialog");
        },
    },
};
</script>

<style lang="scss">
.agreementDialog {
    position: absolute !important;
    top: 20px;
    bottom: 20px;
    left: 50%;
    margin: 0;
    margin-top: 0 !important;
    margin-left: -425px !important;

    .el-dialog__header {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        text-align: center;
        font-weight: bold;
        border-bottom: 1px solid #ddd;
    }

    .el-dialog__body {
        position: absolute;
        top: 55px;
        bottom: 70px;
        overflow: auto;
        padding: 30px;
    }

    .el-dialog__footer {
        position: absolute;
        left: 0;
        bottom: 0;
        right: 0;
        text-align: center;
        border-top: 1px solid #ddd;
    }
}
</style>

<style lang="scss" scoped>
.agreement-container {
    .content-title {
        font-size: 16px;
        font-weight: bold;
        line-height: 30px;
        margin: 15px 0;
    }

    .content-text {
        font-size: 15px;
        text-indent: 2em;
        line-height: 30px;

        b {
            font-weight: bold;
            text-decoration: underline;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Agreement.vue